/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_SubmitInputs */

const en_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Answer`)
};

const de_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort einreichen`)
};

const fr_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre la réponse`)
};

const es_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar respuesta`)
};

const it_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia risposta`)
};

const nl_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwoord indienen`)
};

const pl_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij odpowiedź`)
};

const fi_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä vastaus`)
};

const da_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsend svar`)
};

const sv_interview_practice_submit = /** @type {(inputs: Interview_Practice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka svar`)
};

/**
* | output |
* | --- |
* | "Submit Answer" |
*
* @param {Interview_Practice_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_submit = /** @type {((inputs?: Interview_Practice_SubmitInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_SubmitInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_submit(inputs)
	if (locale === "fr") return fr_interview_practice_submit(inputs)
	if (locale === "es") return es_interview_practice_submit(inputs)
	if (locale === "it") return it_interview_practice_submit(inputs)
	if (locale === "nl") return nl_interview_practice_submit(inputs)
	if (locale === "pl") return pl_interview_practice_submit(inputs)
	if (locale === "fi") return fi_interview_practice_submit(inputs)
	if (locale === "da") return da_interview_practice_submit(inputs)
	if (locale === "sv") return sv_interview_practice_submit(inputs)
	return en_interview_practice_submit(inputs)
});